import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["assetIds", "parentPlaylistId", "hasSuccessAlert"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { getTranslatedErrorMessage } from 'utils/i18n';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { playlistQueryKeys } from 'actions/playlists';
import assetQueryKeys from './queryKeys';
function useUpdateAssets(_ref) {
  var assetIds = _ref.assetIds,
    parentPlaylistId = _ref.parentPlaylistId,
    _ref$hasSuccessAlert = _ref.hasSuccessAlert,
    hasSuccessAlert = _ref$hasSuccessAlert === void 0 ? false : _ref$hasSuccessAlert,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();

  // TODO: refactor the api call to take multiple asset ids and update them all at once
  function patchAssets(_x) {
    return _patchAssets.apply(this, arguments);
  }
  function _patchAssets() {
    _patchAssets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(assetData) {
      var updateAssetById, _updateAssetById;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _updateAssetById = function _updateAssetById3() {
              _updateAssetById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
                var data;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return api('patch', "/api/assets/".concat(id), null, assetData);
                    case 2:
                      data = _context2.sent;
                      return _context2.abrupt("return", data);
                    case 4:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return _updateAssetById.apply(this, arguments);
            };
            updateAssetById = function _updateAssetById2(_x2) {
              return _updateAssetById.apply(this, arguments);
            }; // Run changes for each asset sequentially
            return _context3.abrupt("return", assetIds.reduce(/*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(arr, assetId) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return arr;
                    case 2:
                      return _context.abrupt("return", updateAssetById(assetId));
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }(), Promise.resolve()));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _patchAssets.apply(this, arguments);
  }
  var _useMutation = useMutation(patchAssets, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        assetIds.forEach(function (id) {
          queryClient.invalidateQueries(assetQueryKeys.singleAsset(id));
        });
        if (parentPlaylistId) {
          queryClient.invalidateQueries(playlistQueryKeys.singlePlaylist(parentPlaylistId));
        }
        if (hasSuccessAlert) {
          setSuccessAlert({
            title: assetIds.length > 1 ? t('alert_assets_updated_success') : t('alert_asset_updated_success')
          });
        }
      },
      onError: function onError(error, variables) {
        setAlert({
          title: variables.type ? t("alert_update_".concat(variables.type, "_error")) : t('alert_update_asset_error'),
          message: getTranslatedErrorMessage(error)
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateAssets: mutateAsync
  });
}
export default useUpdateAssets;